import {Form} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

export type invertSelectionEvent = () => void

interface InvertSelectionProps {
    invertSelectionEvent : invertSelectionEvent
    checked? : boolean
}

export const InvertSelection = ({invertSelectionEvent, checked} : InvertSelectionProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    function fireInvertSelectionEvent()
    {
        if (invertSelectionEvent !== undefined) {
            invertSelectionEvent();
        }
    }

    return (
        <span className={"invert-selection btn btn-link p-0 align-bottom"} title={t("common.invert-selection")}>
            <Form.Check type="checkbox" checked={checked} onClick={fireInvertSelectionEvent} readOnly/>
        </span>
    )
}
